<div [formGroup]="formGroup" class="pure-g">
  <!-- Shop Code (Disabled in Edit Mode) -->
  <div class="pure-u-1 pure-u-md-1-3 p-r-8 p-b-16">
    <mc-input
      ngDefaultControl
      label="Shop Code"
      formControlName="shopCode"
      [attr.invalid]="isControlInErrorState(formGroup.controls['shopCode'])"
      fit="small"
      required
      [disabled]="true"
      oninput="this.value = this.value.toUpperCase()">
      @if (formGroup.get('shopCode')?.hasError('required')) {
        <span slot="errormessage">Shop Code is required</span>
      }
      @if (formGroup.get('shopCode')?.hasError('minlength') || formGroup.get('shopCode')?.hasError('maxlength')) {
        <span slot="errormessage">Shop Code must be exactly 3 characters</span>
      }
    </mc-input>
  </div>

  <!-- Shop Type -->
  <div class="pure-u-1 pure-u-md-2-3 p-b-16">
    <mc-select
      ngDefaultControl
      label="Shop Type"
      formControlName="shopType"
      [attr.invalid]="isControlInErrorState(formGroup.controls['shopType'])"
      fit="small"
      required>
      @for (type of shopTypes; track type.code) {
        <mc-option [value]="type.code">{{ type.description }}</mc-option>
      }
      @if (formGroup.get('shopType')?.hasError('required')) {
        <span slot="errormessage">Shop Type is required</span>
      }
    </mc-select>
  </div>

  <!-- Description -->
  <div class="pure-u-1 p-b-16">
    <mc-input
      ngDefaultControl
      label="Description"
      formControlName="description"
      [attr.invalid]="isControlInErrorState(formGroup.controls['description'])"
      fit="small"
      required>
      @if (formGroup.get('description')?.hasError('required')) {
        <span slot="errormessage">Description is required</span>
      } @else if (formGroup.get('description')?.hasError('maxlength')) {
        <span slot="errormessage">Description cannot exceed 200 characters</span>
      }
    </mc-input>
  </div>

  <!-- Email Address -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-input
      ngDefaultControl
      formControlName="emailAddress"
      type="email"
      fit="small"
      [attr.invalid]="isControlInErrorState(formGroup.controls['emailAddress'])">
      <span slot="label">Email Address <span class="mds-neutral--weak__text-color">(Optional)</span></span>
      @if (formGroup.get('emailAddress')?.hasError('email')) {
        <span slot="errormessage">Invalid email format</span>
      } @else if (formGroup.get('emailAddress')?.hasError('maxlength')) {
        <span slot="errormessage">Email cannot exceed 60 characters</span>
      }
    </mc-input>
  </div>

  <!-- Phone Number -->
  <div class="pure-u-1 pure-u-md-1-2 p-b-16">
    <mc-input
      ngDefaultControl
      formControlName="phoneNumber"
      fit="small"
      [attr.invalid]="isControlInErrorState(formGroup.controls['phoneNumber'])">
      <span slot="label">Phone Number <span class="mds-neutral--weak__text-color">(Optional)</span></span>
      @if (formGroup.get('phoneNumber')?.hasError('maxlength')) {
        <span slot="errormessage">Phone number cannot exceed 20 characters</span>
      }
    </mc-input>
  </div>

  <!-- Shop Location -->
  <div class="pure-u-1 p-b-16">
    <mc-typeahead
      ngDefaultControl
      label="Shop Location"
      formControlName="shopLocation"
      [attr.invalid]="isControlInErrorState(formGroup.controls['shopLocation'])"
      [data]="locationCodesList"
      showlistonfocus="true"
      maxoptions="20"
      optionsheight="400px"
      fit="small"
      required
      (optionselected)="onLocationSelected($event)">
      @if (formGroup.get('shopLocation')?.hasError('required')) {
        <span slot="errormessage">Shop Location is required</span>
      }
    </mc-typeahead>
  </div>
</div>
